import { Box, Typography, Button, IconButton, Tooltip, makeStyles } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import Card from "../../Card";

const useStyles = makeStyles({
  ansWrapper: {
    padding: '0.5rem 0',
    borderBottom: '1px solid #f0f0f0',
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  ans: { 
    fontSize: '1.2rem', 
    display: 'flex',
    alignItems: 'baseline'
  },
  correct: { 
    color: 'var(--garnish-primary-green)', 
    fontWeight: 'bold' 
  },
  feedback: {
    fontSize: '1.1rem',
    color: '#666',
    fontStyle: 'italic',
    marginTop: '0.4rem',
    marginLeft: '2rem', 
    background: '#f4f4f4',
    padding: '0.4rem 0.8rem',
    borderRadius: '4px',
    display: 'inline-block',
    borderLeft: '3px solid #ccc'
  },
  marker: {
    marginRight: '0.8rem',
    minWidth: '1.5rem',
    textAlign: 'center'
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  }
});

export default function QuizQuestionPreview({ question, onEditClick, onDeleteClick, isDeleteDisabled }) {
  const classes = useStyles();

  // Define the specific text requested
  const deleteTooltipTitle = isDeleteDisabled 
    ? "You cannot delete this question because it's the only question in the quiz" 
    : "Delete Question";

  return (
    <Card className="mb-2">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">{question.questionText}</Typography>
        <div className={classes.actions}>
          {/* We must wrap the disabled IconButton in a <span> (or div) so that the 
             Tooltip can capture the mouse events required to show the text.
          */}
          <Tooltip title={deleteTooltipTitle} arrow>
            <span>
              <IconButton 
                aria-label="delete" 
                onClick={() => onDeleteClick(question)}
                disabled={isDeleteDisabled}
              >
                <DeleteIcon />
              </IconButton>
            </span>
          </Tooltip>

          <Button variant="outlined" color="primary" startIcon={<EditIcon />} onClick={() => onEditClick(question)}>
            Edit
          </Button>
        </div>
      </Box>
      <Box mt={1}>
        {question.answers.map(a => (
          <div key={a.id} className={classes.ansWrapper}>
            <div className={`${classes.ans} ${a.correct ? classes.correct : ''}`}>
              <span className={classes.marker}>{a.correct ? "✓" : "•"}</span>
              <span>{a.answerText}</span>
            </div>
            {a.feedbackText && (
              <div className={classes.feedback}>
                Feedback: {a.feedbackText}
              </div>
            )}
          </div>
        ))}
      </Box>
    </Card>
  );
}